'use strict'; /*jslint react:true*/
import React from 'react';
import {Error} from '@pub/comp/error.js';

export default function Routing({code}){
    return <Error code={code}/>;
}
